import React, { useState } from "react";
const content = [
  {
    title: "Join a Challenge & post scores",
    h1: "A Challenge is a virtual competition that takes place at a single course over a certain period of time.",
    h2: "Participating is easy! First, ensure you have an active Handicap Index®. Then, all you need to do is join the Challenge and post your scores at the course during the Challenge period.",
  },
  {
    title: "Your net scores will count toward the challenge",
    h1: "A net score uses your Course Handicap to help you measure your performance relative to your skill level. Your Course Handicap takes the difficulty of the course and selected tees into account.",
    h2: "To get your Net Score, we subtract your Course Handicap from your Adjusted Gross Score.",
    content: (
      <div className="score-calculation">
        <div className="score-item">
          <span className="score-label">ADJ. GROSS SCORE</span>
          <span className="score-value">86</span>
        </div>
        <div className="score-operator">-</div>
        <div className="score-item">
          <span className="score-label">COURSE HANDICAP</span>
          <span className="score-value">12</span>
        </div>
        <div className="score-operator">=</div>
        <div className="score-item">
          <span className="score-label">NET SCORE</span>
          <span className="score-value">
            74 <span className="score-small">(+2)</span>
          </span>
        </div>
      </div>
    ),
  },
  {
    title: "Post 3+ scores to qualify for the leaderboard",
    h1: "Once you post 3 scores, you will qualify to get your ranking on the leaderboard.",
    h2: "Your top 3 net scores will determine your final position. During the challenge period, post as many 18-hole scores as you want to try to climb the leaderboard.",
  },
];

const JoinChallengeInfoModal = ({ isOpen, closeModal }) => {
  const [currentStep, setCurrentStep] = useState(0);

  if (!isOpen) return null;

  const handleNext = () => {
    if (currentStep < content.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="step-number">{currentStep + 1}</div>
        <button
          className="close-modal"
          onClick={() => {
            setCurrentStep(0);
            closeModal();
          }}
        >
          &times;
        </button>
        <p className="step-title">{content[currentStep].title}</p>
        <p className="step-description">{content[currentStep].h1}</p>
        <p className="step-description">{content[currentStep].h2}</p>
        {content[currentStep].content && (
          <div className="additional-content">
            {content[currentStep].content}
          </div>
        )}
        <div className="bottom-navigation">
          <div className="dots-navigation">
            {content.map((_, index) => (
              <div
                key={index}
                className={`dot ${index === currentStep ? "active" : ""}`}
              ></div>
            ))}
          </div>
          <div className="modal-navigation">
            {currentStep === 1 && (
              <button
                className="prev-button"
                onClick={handlePrev}
                disabled={currentStep === 0}
              >
                {"< Previous"}
              </button>
            )}
            {currentStep < content.length - 1 ? (
              <button className="next-button" onClick={handleNext}>
                {"Next >"}
              </button>
            ) : (
              <button
                className="close-button"
                onClick={() => {
                  setCurrentStep(0);
                  closeModal();
                }}
              >
                Back To Challenge
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinChallengeInfoModal;
